import { defineMessages } from 'react-intl';

const trns = defineMessages({
  comfortableSearchLabel: {
    id: 'tbcGY+',
    defaultMessage: 'ЗРУЧНИЙ ПОШУК МЕДИЧНИХ ПРЕПАРАТІВ'
  },
  errorPageTitle: {
    id: 'AMdT7T',
    defaultMessage: 'Сталася помилка!'
  },
  oops: {
    id: '5B16Wx',
    defaultMessage: 'Упс!'
  },
  errorDescription: {
    id: 'JZ7/oA',
    defaultMessage:
      'Сторінки не знайдено або \n' +
      'вона у розробці. \n' +
      'Повертайтеся пізніше.'
  },
  returnTo: {
    id: 'w+i/zF',
    defaultMessage: 'повернутися на'
  },
  main: {
    id: 'bWzJCG',
    defaultMessage: 'головну'
  },
  searchTitle: {
    id: 'x/qMse',
    defaultMessage: 'Можливо, щось знайдеться у пошуку?'
  },
  use: {
    id: 'Va3IK/',
    defaultMessage: 'Використовуйте'
  },
  catalog: {
    id: 'Q98YxJ',
    defaultMessage: 'каталог'
  },
  findProducts: {
    id: 'ju3Mua',
    defaultMessage: 'для пошуку товарів'
  },
  repeatProblem: {
    id: 'X0Q4xx',
    defaultMessage: 'Якщо проблема повторюється,'
  },
  contactUs: {
    id: '+pZLeu',
    defaultMessage: 'зв’яжіться з нами'
  },
  backToMain: {
    id: 'QofKIU',
    defaultMessage: 'Перейти на головну'
  },
  comeBack: {
    id: 'T1Kf7m',
    defaultMessage: 'Повернутися назад'
  },
  sorryForInconvenience: {
    id: 'OL6QFz',
    defaultMessage: 'Вибачаємося за незручності.'
  }
});

export default trns;
